import { cn } from "@/modules/lib/utils"
import { type HUImage } from "@modules/types/imageTypes"
import { AnimatePresence, motion } from "motion/react"
import { useState } from "react"
import { Blurhash } from "react-blurhash"

type ImageType = Omit<HUImage, "hash" | "key"> & {
  hash?: string
}

type Props = {
  size: string // Use className to set the size of image and blurhash
  image?: ImageType
  children?: React.ReactNode
  className?: string
} & React.ComponentProps<"div">

export function HUBackgroundImageView({ size, image, className, children, ...props }: Props) {
  const [isImageInCache, setIsImageInCache] = useState<boolean>(false)

  const handleLoad = () => {
    setIsImageInCache(true)
  }

  return (
    <div
      style={{ backgroundImage: image && isImageInCache ? `url(${image.url})` : undefined }}
      {...props}
      className={cn("flex flex-col bg-cover bg-center bg-no-repeat", className, size)}
    >
      {!isImageInCache && image?.hash && (
        <AnimatePresence>
          <motion.div
            animate={{ opacity: [0.4, 0.8, 0.4] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            exit={{ opacity: 0 }}
            style={{ position: "absolute" }}
            className={cn("flex", size)}
          >
            <Blurhash hash={image.hash} style={{ flex: 1, width: "100%", height: "100%" }} />
          </motion.div>
        </AnimatePresence>
      )}
      {image && <img src={image.url} alt="" onLoad={handleLoad} className={"hidden"} />}
      {(isImageInCache || !image) && children}
    </div>
  )
}
